export * from './post-kopieren.component';
export * from './post-kopieren.component.module';